/**
 * Whether a free-text answer (a title, a message, a name) is shaped like a
 * question rather than a value: it should never be swallowed as the answer
 * without a second look, in case it's really a side question.
 */

/**
 * Starts like a question: "where are my drafts?", "what role is Jeremy". Deliberately
 * narrower than `replyTo.ts`'s own `QUESTION_START` (which also catches "which", "are",
 * "should" and more, tuned for deciding whether a message starts a task): this is the
 * exact word list the side-question ticket specifies, so it isn't shared with that one.
 */
const QUESTION_START = /^(?:what|who|where|how|can|why|do|is)\b/i;

export const looksLikeQuestion = (text: string): boolean => {
  const trimmed = text.trim();
  return /\?\s*$/.test(trimmed) || QUESTION_START.test(trimmed);
};

/** A plausible full name is never shaped like a question, and never more than a few words. */
const NAME_WORD_LIMIT = 5;

export const isPlausibleName = (text: string): boolean => {
  const trimmed = text.trim();
  if (!trimmed || looksLikeQuestion(trimmed)) return false;
  return trimmed.split(/\s+/).length <= NAME_WORD_LIMIT;
};
